import { Injectable } from '@angular/core';
import { EntityState, EntityStore, MultiActiveState, StoreConfig } from '@datorama/akita';
import { LegalEntity } from './legal-entity.model';
import { getName } from 'country-list';

export interface LegalEntityState
    extends EntityState<LegalEntity, LegalEntity['ownerId']>,
        MultiActiveState {}
const initialState = {
    active: []
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'legal-entities', idKey: 'ownerId' })
export class LegalEntityStore extends EntityStore<LegalEntityState> {
    constructor() {
        super(initialState);
    }

    akitaPreAddEntity(legalEntity: LegalEntity) {
        return {
            ...legalEntity,
            displayName:
                legalEntity.displayName || legalEntity.shortName || legalEntity.longName
        };
    }

    akitaPreUpdateEntity(legalEntity: LegalEntity, updatedLegalEntity: LegalEntity) {
        return legalEntity;
    }
}

export const transformOwnerToLegalEntity = (owner: LegalEntity) => {
    return {
        id: owner.ownerId,
        name: owner.longName,
        displayName: owner.shortName || owner.longName,
        logoUrl: owner.logoUrl,
        website: owner.website,
        type: owner.legalType,
        address: {
            street: owner.addressLine1,
            city: owner.addressLine2,
            zip: owner.addressLine3,
            country: owner.addressCountryCode ? getName(owner.addressCountryCode) : null
        }
    };
};
